import { FC } from "react";
import Authorize from "../app/authorize/Authorize.component";

const AuthorizePage:FC = () => <Authorize />

export default AuthorizePage;